<template>
    <MainNav />
    <PopupContainer />
    <ViewBackground />
    <ToastNotifications />
    <router-view/>
    <BottomNav v-if="isBuilder" />
</template>

<script>
    import { throttle } from 'lodash';
    import MainNav from '@/components/navigation/MainNav';
    import BottomNav from '@/components/navigation/BottomNav';
    import PopupContainer from '@/components/popups/PopupContainer';
    import ViewBackground from '@/components/sections/ViewBackground';
    import ToastNotifications from '@/components/misc/ToastNotifications';
    import { useScreenWidthStore } from '@/stores/utils/screenWidth';

    export default {
        components: {
            MainNav,
            BottomNav,
            PopupContainer,
            ViewBackground,
            ToastNotifications
        },
        data() {
            return {
                screenWidthStore: useScreenWidthStore()
            };
        },
        computed: {
            isBuilder() {
                return process.env.VUE_APP_TYPE === 'builder';
            }
        },
        methods: {
            updateWidth() {
                this.screenWidthStore.updateWidth();
            },
            throttledUpdateWidth: throttle(function() {
                this.updateWidth();
            }, 200)
        },
        mounted() {
            this.updateWidth();
            window.addEventListener('resize', this.throttledUpdateWidth);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.throttledUpdateWidth);
        }
    };
</script>